import {
  validateCurrency,
  validateNumericWithZero,
} from "../../../utils/vault/generalValidators.ts";

const yesNoOptions = [
  { label: "Sí", value: true },
  { label: "No", value: false },
];

export const yesNoFormItems = [
  {
    name: "valid_id",
    label: "¿La identificación del inquilino está vigente?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "is_foreign",
    label: "¿Es extranjero?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "valid_migration_form",
    label: "En caso de ser extranjero, ¿tiene forma migratoria vigente?\n",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "cash_income",
    label: "¿Recibe ingresos en efectivo?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "tenant_income",
    label: "¿Los ingresos son del inquilino y alguien más?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "other_tenant_income",
    label: "¿Los ingresos los demuestra otra persona que no es el inquilino?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "valid_income",
    label: "¿El inquilino comprueba ingresos?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "property_under_guarantee",
    label:
      "¿El inmueble otorgado en garantía es de otra persona(s) que no es el fiador?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "representative_has_admin_permissions",
    label:
      "En caso de PM, ¿El representante tiene facultades de administración?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "compliance_opinion_positive",
    label: "En caso de PM, ¿La opinión de cumplimiento es positiva?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "has_guarantor",
    label: "¿Tiene fiador u obligado solidario?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "valid_guarantor_id",
    label: "¿La identificación del fiador/obligado solidario está vigente?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "has_property_under_guarantee",
    label: "¿Deja propiedad en garantía?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "guarantor_is_owner",
    label: "¿El fiador es dueño al 100%?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "unencumbered_property",
    label: "¿El inmueble esta libre de gravamen?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "vehicle_under_guarantee",
    label: "¿Se otorgará un vehículo o maquinaria en garantía?\n",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "will_register_at_rug",
    label: "¿Se registrará en RUG?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
  {
    name: "has_lease_contract",
    label: "¿Se firmará contrato de arrendamiento?",
    rules: [{ required: true, message: "Campo requerido" }],
    options: yesNoOptions,
  },
];

export const currencyFormItems = [
  {
    name: "income_month_1",
    label: "Ingresos mes 1",
    rules: [
      { required: true, message: "Campo requerido" },
      { validator: validateCurrency },
    ],
  },
  {
    name: "income_month_2",
    label: "Ingresos mes 2",
    rules: [
      { required: true, message: "Campo requerido" },
      { validator: validateCurrency },
    ],
  },
  {
    name: "income_month_3",
    label: "Ingresos mes 3",
    rules: [
      { required: true, message: "Campo requerido" },
      { validator: validateCurrency },
    ],
  },
];

export const rentedPropertyAddressFormItem = {
  name: "rented_property_address",
  label: "Domicilio del inmueble arrendado",
  className: "w-full px-2",
  rows: 6,
  type: "textarea",
  rules: [{ required: true, message: "Campo requerido" }],
};

export const quantityFormItems = [
  {
    name: "payment_months",
    label: "¿Cuántos meses paga por adelantado?",
    rules: [
      { required: true, message: "Campo requerido" },
      { validator: validateNumericWithZero },
    ],
  },
  {
    name: "promissory_notes",
    label: "¿Cuántos pagarés firmaran?",
    rules: [
      { required: true, message: "Campo requerido" },
      { validator: validateNumericWithZero },
    ],
  },
];

export const getCollateralPropertyAddressFormItems = (
  isNewRegistryReceipt?: boolean,
  accreditationType?: "boleta_registral" | "predial" | "escrituras",
) => {
  const isPredial = accreditationType === "predial";
  const isEscrituras = accreditationType === "escrituras";
  const items: any[] = [
    {
      name: "guarantee_accreditation_type",
      label: "¿Con qué se acredita el inmueble en garantía?",
      type: "radio",
      rules: [{ required: true, message: "Campo requerido" }],
      initialValue: "boleta_registral",
      options: [
        { label: "Boleta registral", value: "boleta_registral" },
        { label: "Predial", value: "predial" },
        { label: "Escrituras", value: "escrituras" },
      ],
    },
  ];

  // The "is the registry receipt new?" question is only relevant for the
  // boleta_registral path — predial and escrituras are alternative
  // accreditation documents that don't carry the new/renewed distinction.
  if (!isPredial && !isEscrituras) {
    items.push({
      name: "is_new_boleta_registral",
      label: "¿La boleta registral es nueva?",
      type: "radio",
      rules: [{ required: true, message: "Campo requerido" }],
      initialValue: true,
      options: [
        { label: "Sí", value: true },
        { label: "No", value: false },
      ],
    });
  }

  items.push({
    name: "folio_real",
    label: isPredial
      ? "Cuenta Predial"
      : isEscrituras
        ? "Escrituras"
        : isNewRegistryReceipt
          ? "Folio Real"
          : "Folio Real (opcional)",
    type: "input",
    rules:
      isPredial || isEscrituras || isNewRegistryReceipt
        ? [{ required: true, message: "Campo requerido" }]
        : [{ required: false }],
  });
  items.push({
    name: "superficie",
    label: "Superficie (opcional)",
    type: "input",
    rules: [{ required: false }],
  });
  items.push({
    name: "full_address",
    label: "Domicilio de la propiedad en garantía",
    className: "w-full px-2",
    rows: 6,
    type: "textarea",
    rules: [{ required: true, message: "Campo requerido" }],
  });
  return items;
};

